import { ISuggestion } from '../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import { notNullOrUndefined } from '../../../../../../Utils/utils';
import {
  TEDEKBokforderSTATUSEnum,
  TEDEKBokforderTYPEnum,
  TEDEKBokforderVariantEnum,
  TEDOPOrgPersLokTypEnum,
  TEDSYSUtbetalningssattBETSATTEnum,
} from '../../../../../../globalQueryTypes';
import { FranvaroReservForQuery_db_SYSFranvaro_All } from '../../../../SystemAdministration/ObjektVyer/User/Components/FranvaroReservFor/Queries/_QueryTypes/FranvaroReservForQuery';
import { IBusinessDataFormState } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import {
  BusinessDataFormAction,
  IFormData,
  IUpdateValue,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { IBokforderKodbehorigheter } from '../../../../_Common/Components/KonteringManager/KonteringContext';
import { IKodstrang } from '../../../../_Common/Components/KonteringManager/KonteringManager';
import { KonteringUtils } from '../../../../_Common/Components/KonteringManager/KonteringManagerUtils';
import { IKontodel } from '../../../../_Common/Components/KonteringManager/Query/KonteringManagerQuery';
import {
  DefaultBfoVariantEnum,
  IUserBokforderKodbehorigheter,
} from '../Components/BokforderContext/BokforderContextManager';
import { KonteringsmallQuery } from '../Components/BokforderCreateDialog/Queries/_QueryTypes/KonteringsmallQuery';
import {
  UtanordningType,
  UtanordningType__Associations_Rader,
} from '../Queries/_QueryTypes/UtanordningType';
import {
  filterUsersOnKodstrang,
  findFranvaroForUser,
  getUserKodbehsBasedOnKodstrang,
  isRowEmpty,
} from './BokforderUtils';

export const validBankkontoUtbetalningsatt = [
  TEDSYSUtbetalningssattBETSATTEnum.PLUSGIRO___KONTOINSATTNING_TILL_BANKKONTO,
  TEDSYSUtbetalningssattBETSATTEnum.BANKGIRO___KONTOINSATTNING_UTAN_AVISERING,
  TEDSYSUtbetalningssattBETSATTEnum.KONTOINSATTNING,
];

export const validPGBGUtbetalingsatt = [
  TEDSYSUtbetalningssattBETSATTEnum.PLUSGIRO___GIRERING_TILL_PLUSGIROKONTO,
  TEDSYSUtbetalningssattBETSATTEnum.BANKGIRO___GIRERING_TILL_BANKGIROKONTO,
  TEDSYSUtbetalningssattBETSATTEnum.BANKGIRO___BETALNING_TILL_PLUSGIRONUMMER,
  TEDSYSUtbetalningssattBETSATTEnum.BANKGIRO_MED_MEDDELANDE,
  TEDSYSUtbetalningssattBETSATTEnum.PLUSGIRO_MED_MEDDELANDE,
];

export const validMessageUtbetalningsatt = [
  TEDSYSUtbetalningssattBETSATTEnum.BANKGIRO_MED_MEDDELANDE,
  TEDSYSUtbetalningssattBETSATTEnum.PLUSGIRO_MED_MEDDELANDE,
  TEDSYSUtbetalningssattBETSATTEnum.KONTOINSATTNING,
];

export const getUpdatedUtanordningAction = (
  value: IUpdateValue,
  formState: IBusinessDataFormState<IFormData, unknown>
): IUpdateValue => {
  const currentUtanordingValues = formState.currentValues as UtanordningType;
  if (value['U_BELOPP'] != null) {
    const rows: UtanordningType__Associations_Rader[] =
      currentUtanordingValues._Associations?.Rader ?? [];

    const nonEmptyRows = rows.filter(row => !isRowEmpty(row, false));

    if (nonEmptyRows.length === 1 || rows.length === 1) {
      const rowToBeEdited = rows[0];

      const updatedRowsArray = [rowToBeEdited];
      if (rowToBeEdited.id.includes('New')) {
        rowToBeEdited.DEBET = value['U_BELOPP'];
        return {
          _Associations: {
            Rader_Add_Values: updatedRowsArray,
          },
          ...value,
        };
      } else {
        const updatedRow = { id: rowToBeEdited.id, DEBET: value['U_BELOPP'] };
        return {
          _Associations: {
            Rader_Update_Values: [updatedRow],
          },
          ...value,
        };
      }
    }
  }
  return value;
};

export const utanordningFormStateActionTransformer = (
  action: Readonly<BusinessDataFormAction>,
  formState: IBusinessDataFormState<IFormData, unknown>
): BusinessDataFormAction => {
  switch (action.type) {
    case 'UPDATE':
      return {
        ...action,
        value: getUpdatedUtanordningAction(action.value, formState),
      };

    default:
      return action;
  }
};

export const filterUtbetalningssatt = (
  bokforderVariant: TEDEKBokforderVariantEnum | DefaultBfoVariantEnum | null,
  objectLankDefaultValues: ISuggestion[],
  tillgodohavandeKundTyp?: TEDOPOrgPersLokTypEnum
): ISuggestion[] => {
  return objectLankDefaultValues.filter(defaultValue => {
    if (
      bokforderVariant === TEDEKBokforderVariantEnum.UTANORDINGBANKONTO &&
      !validBankkontoUtbetalningsatt.includes(defaultValue.data?.BETSATT)
    ) {
      return;
    } else if (
      bokforderVariant === TEDEKBokforderVariantEnum.UTANORDINGPGBG &&
      !validPGBGUtbetalingsatt.includes(defaultValue.data?.BETSATT)
    ) {
      return;
    } else if (
      bokforderVariant === TEDEKBokforderVariantEnum.UTANORDNINGTILLGODO
    ) {
      if (
        tillgodohavandeKundTyp === TEDOPOrgPersLokTypEnum.PERSON &&
        !validBankkontoUtbetalningsatt.includes(defaultValue.data?.BETSATT)
      ) {
        return;
      }

      if (
        tillgodohavandeKundTyp !== TEDOPOrgPersLokTypEnum.PERSON &&
        !(
          validBankkontoUtbetalningsatt.includes(defaultValue.data?.BETSATT) ||
          validPGBGUtbetalingsatt.includes(defaultValue.data?.BETSATT)
        )
      ) {
        return;
      }
    }

    const result =
      defaultValue.data?.BORTTAGEN !== true &&
      defaultValue.data?._Associations?.Utbetalningsvag.AKTIV === true &&
      defaultValue.data?._Associations?.Utbetalningsvag.BORTTAGEN !== true;
    return result;
  });
};

export const getKontodelarFromKonteringsMall = (
  data: KonteringsmallQuery,
  kodplanId: string,
  bokforderDate: Date,
  konteringUtils: KonteringUtils
): IKontodel[] => {
  const actualKontodelar: IKontodel[] = [];
  if (data.ekkonteringsmall) {
    for (const [key, value] of Object.entries(data.ekkonteringsmall)) {
      if (key.includes('Kontodel')) {
        const ordningsNr = key.replace(/^\D+/g, '');
        const actualKontodel = konteringUtils.getKontodelByKontodel(
          kodplanId,
          parseInt(ordningsNr),
          value?.KONTODEL ?? '',
          bokforderDate
        );

        if (actualKontodel) {
          actualKontodelar.push(actualKontodel);
        }
      }
    }
  }
  return actualKontodelar;
};

export const filterValidKontrollattestantOption = (
  bestallareID: string | null | undefined,
  kontrollattestant: IUserBokforderKodbehorigheter,
  kodstrangar: IKodstrang[],
  franvaroReservForData: FranvaroReservForQuery_db_SYSFranvaro_All[],
  franvaroReservForQueryLoading: boolean,
  userID: string | null,
  uBelopp: number | null | undefined,
  rows: UtanordningType__Associations_Rader[],
  status: TEDEKBokforderSTATUSEnum | null | undefined
) => {
  const hasKodbehsValidOnEveryRow = kodstrangar.every(currentKodstrang => {
    return filterUsersOnKodstrang(currentKodstrang.kontodelar)(
      kontrollattestant
    );
  });

  const attestanterOnRows =
    rows
      ?.map((row: any) => row._Associations?.Attestant?.id)
      .filter(notNullOrUndefined) ?? [];

  const kontrollattestantPickedOnRow = attestanterOnRows.includes(
    kontrollattestant.userID
  );

  const isKontrollattestantBestallare =
    bestallareID === kontrollattestant.userID ||
    (status == null && kontrollattestant.userID === userID);

  const isReservBestallare =
    bestallareID === userID ||
    (status == null && kontrollattestant.userID === userID);

  const reserverForKontrollattestant = franvaroReservForData.filter(franvaro =>
    findFranvaroForUser(
      kontrollattestant.userID,
      TEDEKBokforderTYPEnum.UTANORDNING,
      new Date(),
      franvaro
    )
  );

  const isReservForKontrollattestant = reserverForKontrollattestant.some(
    franvaro => franvaro._Associations?.Reserv?.id === userID
  );

  const rowsContainsCurrentUser =
    isReservForKontrollattestant && attestanterOnRows.includes(userID);

  const isReservAndAlreadyInvolved =
    isReservForKontrollattestant &&
    (isReservBestallare ||
      kontrollattestantPickedOnRow ||
      rowsContainsCurrentUser) &&
    !franvaroReservForQueryLoading;

  const kontrollKodbehs: IBokforderKodbehorigheter[] =
    getUserKodbehsBasedOnKodstrang(kodstrangar, kontrollattestant);

  const beloppInRangeForAtLeastOneKodbeh = kontrollKodbehs.some(kodbeh => {
    if (kodbeh) {
      return (
        kodbeh.UTANORDNING_KA_MAXBELOPP == null ||
        (kodbeh.UTANORDNING_KA_MAXBELOPP &&
          kodbeh.UTANORDNING_KA_MAXBELOPP >= (uBelopp ?? 0))
      );
    }
    return false;
  });

  return (
    hasKodbehsValidOnEveryRow &&
    !kontrollattestantPickedOnRow &&
    beloppInRangeForAtLeastOneKodbeh &&
    !isKontrollattestantBestallare &&
    !isReservAndAlreadyInvolved
  );
};
